import { render } from "./FormBody.vue?vue&type=template&id=d84d6920&scoped=true"
import script from "./FormBody.vue?vue&type=script&lang=js"
export * from "./FormBody.vue?vue&type=script&lang=js"

import "./../../../assets/styles/admin/form.scss?vue&type=style&index=0&id=d84d6920&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d84d6920"]])

export default __exports__